module.exports = __webpack_public_path__ + "img/user-bai.27242f12.svg";